import { render, staticRenderFns } from "./TabelaPagamento.vue?vue&type=template&id=1da2d3c8&scoped=true&"
import script from "./TabelaPagamento.vue?vue&type=script&lang=js&"
export * from "./TabelaPagamento.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPagamento.vue?vue&type=style&index=0&id=1da2d3c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da2d3c8",
  null
  
)

export default component.exports